module.exports = __webpack_public_path__ + "static/media/apple.49d2b7c3.png";